import { render, staticRenderFns } from "./warn-pannel.vue?vue&type=template&id=6e85377a&scoped=true&"
import script from "./warn-pannel.vue?vue&type=script&lang=js&"
export * from "./warn-pannel.vue?vue&type=script&lang=js&"
import style0 from "./warn-pannel.vue?vue&type=style&index=0&id=6e85377a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e85377a",
  null
  
)

export default component.exports